import { CircularProgress } from "@material-ui/core";
import { Text } from "components/Typography/text.styled";
import { BannerComponent } from "components/banners/banner.component";
import { PageContainer } from "components/designV2/layout/grid";
import { LoggedOutPageContainer } from "components/pageLayouts/pageLayouts.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Page } from "web-apps/company/components/schedule/components/views/shared/schedule.styled";
import { Staff } from "web-apps/company/components/staff/staff.component";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

/**
 * Handles staff page.
 */
export const StaffPage = () => {
  const [companyState] = useCompanyStore();
  const [authState] = useCompanyStore();
  const { t } = useTranslation();
  return (
    <Page>
      <TimeReportsPageContainer>
        {authState.isLoading || companyState.isLoading ? (
          <LoggedOutPageContainer>
            <CircularProgress />
          </LoggedOutPageContainer>
        ) : (
          <>
            {companyState.company?.verified ? (
              <Staff />
            ) : (
              <BannerComponent
                icon="clock"
                backgroundColor={Color.ChampagnePink}
                fill={Color.Destructive}
              >
                <Text
                  fontSize={FontSize.Large}
                  fontFamily={FontFamily.MontserratSemiBold}
                  color={Color.Destructive}
                >
                  {t("GigsCompany.UnverifiedAccount")}
                </Text>
                <Text>{t("GigsCompany.UnverifiedAccountDetails")}</Text>
              </BannerComponent>
            )}
          </>
        )}
      </TimeReportsPageContainer>
    </Page>
  );
};

const TimeReportsPageContainer = styled(PageContainer)`
  margin-top: 0;
`;
